import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { authUserRequest, authUserSuccess, authUserFailure } from '../reducers/login';
import { API_LINK } from '../../constants';
import { xapiRequest } from '../reducers/xapi';
import { CookiesProvider, Cookies } from 'react-cookie';

const API = `${API_LINK}api/getAuthUser`;


function getUserTimeZone() {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return userTimeZone;
}

// Usage example
const userTimeZone = getUserTimeZone();



function* authUserFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { token } = state.loginReducer;

  return yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      data: {
        token,
        userTimeZone:userTimeZone
      },
    }),
  );
}

function* workerAuthUserSaga() {
  const cookies = new Cookies();
  try {
    const response = yield call(authUserFunctionAxios);
    const responseFromLogin = response.data;
    yield put(xapiRequest({ xapiType: 'Returned' }));
    if (response.status === 200) {
      yield put(authUserSuccess(responseFromLogin));
      
    }
    if (response.status === 401) {
      yield put(authUserFailure(response));
      cookies.remove('token')
    }
    if (response.status === 500) {
      yield put(authUserFailure(response));
      cookies.remove('token')
    }
  } catch (error) {
    cookies.remove('token')
    yield put(authUserFailure(error.response));
  }
}

export function* watcherAuthUserSaga() {
  yield takeLatest(authUserRequest().type, workerAuthUserSaga);
}
